export default __webpack_public_path__ + "static/media/resincast3.118db9c2.webp";